module.exports = __webpack_public_path__ + "static/media/icon_chayngam.be003bbc.svg";